import chroma from "chroma-js";

// From a PH colour scale published by The University of Waikato Te Whare Wänanga o Waikato | www.sciencelearn.org.nz
const phScale = chroma.scale([
    "#e3202d", // Fire red
    "#f65531", // Tangerine
    "#fda338", // Orange peel
    "#fdca34", // Golden yellow
    "#dcdc3d", // Lemon zest
    "#95d433", // Lime green
    "#50b31f", // Fresh grass
    "#15991f", // Leaf green
    "#17a55e", // Mint green
    "#1ebfb7", // Tropical teal
    "#1588c4", // Sky blue
    "#0b50c4", // Ocean blue
    "#342eb2", // Indigo dusk
    "#4822b2", // Royal purple
    "#391a8b"  // Deep violet
]
).mode('hsv').domain([0, 14]);

export const getPhColour = (value: number) => {
    return phScale(value).hex();
};
